import { HelpYouSell } from 'shared/landingSeller/components/HelpYouSell';
import { useWithModalForm } from 'shared/common/hooks/useWithModalForm';
import { clickGoToAgentConsultation } from '../../components/tracking';
import { useApplicationContext } from '../../../common/utils/applicationContext';

export const HelpYouSellContainer: React.FC = () => {
  const { handleOpenModal, device } = useWithModalForm();
  const { custom } = useApplicationContext();

  const handleGoToAgentConsultation = () => {
    clickGoToAgentConsultation(custom, 'FindAgentHeader');

    const url = custom.source
      ? `https://www.cian.ru/step-by-step-forms/?formType=sdelka-agent-selection&cian_source=${custom.source}&cpd_message_entrypoint=landingPageFindAgentFooter`
      : `https://www.cian.ru/step-by-step-forms/?formType=sdelka-agent-selection&cpd_message_entrypoint=landingPageFindAgentFooter`;

    window.open(url);
  };

  return (
    <HelpYouSell onOpenModal={handleOpenModal} onConsultationClick={handleGoToAgentConsultation} device={device} />
  );
};
